import React from 'react';
import Anchor from 'gatsby-core-theme/src/components/organisms/anchor/template-one';

export default (props) => {
  return (
    <Anchor
      {...props}
      headerOffset={80}
      heightOfAnchor={69}
      sliderGap={5}
      offset={20}
      showTitle={false}
      isFixed={false}
      setShowButtons={true}
    />
  );
};
